An attempt to deliver a specific `Event` to a `WebhookSubscription`.
